<template>
  <GridPart
      maxWidth="calc(100% - 80px)"
      :title="title"
      :hasSearch="true"
      :hasFilter="false"
      :hasExtra="true"
      :standardClass="() => {}"
      :extraClass="() => {}"
      :colspan="5"
      empty="Nenašli sa žiadne ponuky."
      itemsKey="ticketItemOffers"
      filterKey="TicketItemOffer"
      defaultOrder="ticiteoff.timeEstimation"
      defaultBy="DESC"
      :defaultLimit="25"
      :fetchData="fetchData"
  >
    <template
        v-slot:action="{
          init
        }"
    >
      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
      >
        <template
            v-if="TicketItem.ticketItemOfferCreatable"
        >
          <CreateTicketItem
              :ticketItemId="TicketItem.id"
              @onCreateTicketItem="(response) => {
                init()

                $emit('refresh', response)
              }"
          />

          &nbsp;
        </template>
      </template>
    </template>

    <template
        v-slot:search="{
          params,
          errors,
          setSearch
        }"
    >
      <v-text-field
          v-model="params.query"
          :error-messages="errors.query"
          :outlined="true"
          :dense="true"
          hide-details="auto"
          label="Vyhľadávanie"
          :clearable="true"
          @change="setSearch"
      />
    </template>

    <template
        v-slot:list-head="{
          order,
          by,
          orderList,
          byList,
          setOrderBy
        }"
    >
      <th
          class="fixed"
      >
        Užívateľ
      </th>

      <th>
        <OrderList
            orderKey="ticiteoff.timeEstimation"
            :order="order"
            :by="by"
            :orderList="orderList"
            :byList="byList"
            @setOrderBy="setOrderBy"
        />
      </th>

      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
      >
        <th>
          Plat
        </th>

        <th>
          Odhadovaná suma
        </th>
      </template>

      <th
          class="text-right fixed"
      />
    </template>

    <template
        v-slot:list-body-standard="{
          Item,
          init
        }"
    >
      <td
          class="fixed"
      >
        <TruncateHelper
            :title="Item.User.name"
            maxWidth="300px"
        >
          {{ Item.User.name }}
        </TruncateHelper>
      </td>

      <td>
        {{ Item.timeEstimation|number }} h
      </td>

      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
      >
        <td>
          {{ Item.priceHour|currency('€ / h') }}
        </td>

        <td>
          {{ Item.priceEstimation|currency('€') }}
        </td>
      </template>

      <td
          class="text-right fixed"
      >
        <template
            v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
        >
          <template
              v-if="Item.updatable"
          >
            <Update
                :id="Item.id"
                @onUpdate="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>

          <template
              v-if="Item.deletable"
          >
            &nbsp;

            <Delete
                :id="Item.id"
                @onDelete="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>
        </template>
      </td>
    </template>

    <template
        v-slot:list-body-extra="{
          Item
        }"
    >
      <td
          :colspan="5"
      >
        <IsEmptyHelper
            :value="Item.note"
            if-no="i"
            if-yes="i"
            empty="bez poznámky"
        >
          {{ Item.note }}
        </IsEmptyHelper>
      </td>
    </template>
  </GridPart>
</template>

<script>
  import TicketItemOffers from '@/services/ticket-item-offers'

  import CreateTicketItem from '@/components/TicketItemOffers/CreateTicketItem'
  import Update from '@/components/TicketItemOffers/Update'
  import Delete from '@/components/TicketItemOffers/Delete'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketItemOffers',
    props: [
      'TicketItem'
    ],
    emits: [
      'refresh'
    ],
    components: {
      CreateTicketItem,
      Update,
      Delete,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper
    },
    data() {
      return {
        title: 'Ponuky'
      }
    },
    methods: {
      fetchData(params) {
        return TicketItemOffers
          .indexTicketItem({
            ticketItemId: this.TicketItem.id,
            params: params
          })
      }
    }
  }
</script>
